export default __webpack_public_path__ + "static/media/16.13816b25.png";